import api from './api';

// Types
export interface WhatsAppReminder {
  type: 'visit' | 'vaccination' | 'deworming' | 'grooming' | 'medical';
  record_id: number;
  patient_name: string;
  patient_species: string;
  owner_name: string;
  // Puede venir null: el recordatorio se muestra igual aunque el dueño no
  // tenga teléfono cargado (antes se ocultaba en silencio).
  owner_phone: string | null;
  owner_email: string | null;
  tenant_name: string;
  date: string;
  reason?: string;
  vaccine_name?: string;
  service_type?: string;
  scheduled_time?: string;
  category?: string;
  type_name?: string;
  pre_op_notes?: string;
  is_expired?: boolean;
  /** null cuando no hay teléfono válido para armar el link. */
  whatsapp_link: string | null;
  whatsapp_message: string;
}

export interface WhatsAppRemindersResponse {
  total_reminders: number;
  reminders: WhatsAppReminder[];
  instructions: string[];
}

export interface ReminderStats {
  stats: Array<{
    days_ahead: number;
    date: string;
    count: number;
  }>;
}

// Helper para generar link de WhatsApp con encoding correcto de emojis
export const generateWhatsAppLink = (phone: string, message: string): string => {
  // Normalizar telefono argentino
  let digits = phone.replace(/\D/g, '');
  if (digits.startsWith('54')) digits = digits.slice(2);
  if (digits.startsWith('9')) digits = digits.slice(1);
  if (digits.startsWith('0')) digits = digits.slice(1);
  digits = '549' + digits;

  // encodeURIComponent maneja emojis correctamente en JS
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${digits}?text=${encoded}`;
};

// API Service
export const remindersService = {
  getWhatsAppReminders: async (): Promise<WhatsAppRemindersResponse> => {
    const response = await api.get('/reminders/whatsapp');
    return response.data;
  },

  markReminderSent: async (recordType: 'visit' | 'vaccination' | 'deworming' | 'grooming' | 'medical', recordId: number): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/reminders/whatsapp/mark-sent/${recordType}/${recordId}`);
    return response.data;
  },

  getStats: async (): Promise<ReminderStats> => {
    const response = await api.get('/reminders/stats');
    return response.data;
  },
};
